import {adminShopUrl, shopUrl} from '../Component/BaseComponent/configTheme'
export const productShop = ({articleId}) => {
  return `${shopUrl}/product/${articleId}`
}

export const orderInfo = ({orderId}) => {
  return `${adminShopUrl}/orders/info/${orderId}`
}

export const editOrder = ({invoiceId}) => {
  return `${adminShopUrl}/orders/edit/${invoiceId}`
}

export const getParcelInfo = ({parcelId}) => {
  return `${adminShopUrl}/parcels/info/${parcelId}`
}
